type ActivatableDocument = Pick<Document, 'addEventListener'> & { prerendering?: boolean };

export const whenActivated = (document: ActivatableDocument, start: () => void): void => {
  if (document.prerendering === true) document.addEventListener('prerenderingchange', start, { once: true });
  else start();
};
